import { useState, useEffect } from 'react';
import api from '../utils/api';

const ACTION_COLORS = {
  create: { bg: '#10b98122', color: '#10b981', label: 'Created' },
  update: { bg: '#3b82f622', color: '#3b82f6', label: 'Updated' },
  delete: { bg: '#ef444422', color: '#ef4444', label: 'Deleted' },
  login:  { bg: '#8b5cf622', color: '#8b5cf6', label: 'Login' },
  void:   { bg: '#f59e0b22', color: '#f59e0b', label: 'Voided' },
};

export default function AuditLog({ tableName, recordId, style }) {
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!open) return;
    if (logs !== null) return; // already loaded
    setLoading(true);
    api.get(`/audit-log?table_name=${tableName}&record_id=${recordId}&pageSize=50`)
      .then(r => { setLogs(r.data.rows); setTotal(r.data.total); })
      .catch(() => setLogs([]))
      .finally(() => setLoading(false));
  }, [open, tableName, recordId]);

  return (
    <div style={{ marginTop: 20, borderTop: '1px solid var(--border)', paddingTop: 12, ...style }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 6,
          fontSize: 12, color: 'var(--muted)', padding: 0,
          fontWeight: 600
        }}
      >
        <span style={{ transition: 'transform 0.2s', display: 'inline-block', transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}>▶</span>
        {open ? 'Hide' : 'Show'} Change Log
        {total > 0 && <span style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '0 6px', fontSize: 10 }}>{total}</span>}
      </button>

      {open && (
        <div style={{ marginTop: 10 }}>
          {loading && <div style={{ fontSize: 12, color: 'var(--muted)', padding: '8px 0' }}>Loading…</div>}

          {!loading && logs?.length === 0 && (
            <div style={{ fontSize: 12, color: 'var(--muted)', padding: '8px 0' }}>No changes recorded yet.</div>
          )}

          {!loading && logs?.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {logs.map(log => {
                const actionConfig = ACTION_COLORS[log.action] || { bg: '#6b728022', color: '#6b7280', label: log.action };
                return (
                  <div key={log.id} style={{
                    background: 'var(--surface)', borderRadius: 'var(--radius)',
                    padding: '8px 10px', fontSize: 12,
                    borderLeft: `3px solid ${actionConfig.color}`
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{
                          fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 4,
                          background: actionConfig.bg, color: actionConfig.color
                        }}>
                          {actionConfig.label}
                        </span>
                        <span style={{ fontWeight: 600, color: 'var(--text)' }}>{log.user_name || 'System'}</span>
                      </div>
                      <span style={{ color: 'var(--muted)', fontSize: 11 }}>
                        {new Date(log.created_at).toLocaleString()}
                      </span>
                    </div>

                    {log.field_name && (
                      <div style={{ color: 'var(--muted)', fontSize: 11, marginTop: 4 }}>
                        <span style={{ fontWeight: 600, color: 'var(--text)' }}>{log.field_name}</span>
                        {log.old_value && <span> · <span style={{ textDecoration: 'line-through' }}>{log.old_value}</span></span>}
                        {log.new_value && <span> → <span style={{ color: 'var(--text)' }}>{log.new_value}</span></span>}
                      </div>
                    )}

                    {log.notes && (
                      <div style={{ color: 'var(--muted)', fontSize: 11, marginTop: 2 }}>{log.notes}</div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
